const appConfig = {
  firebaseCallbackURL:
    process.env.REACT_APP_FIREBASE_CALLBACK_URL || 'https://app.prodaff.com',

  roles: [
    { value: 'Member', label: 'Member' },
    { value: 'Manager', label: 'Manager' },
    { value: 'Admin', label: 'Admin' },
    { value: 'Client', label: 'Client' },
  ],
};
export const plansKeys = {
  starter: 'starter',
  grow: 'grow',
  team: 'team',
};
export const plans = {
  // live / prodaff checkout
  plan_SdHUFngYqTtllr: {
    name: 'Starter_Month',
    label: 'Starter',
    key: plansKeys.starter,
    id: 'plan_SdHUFngYqTtllr',
    billingCycle: 'month',
    price: 7,
    currency: 'USD',
    currencySymbol: '$',
  },
  plan_SdHV5J8X1tPZfX: {
    name: 'Grow_Month',
    label: 'Grow',
    key: plansKeys.grow,
    id: 'plan_SdHV5J8X1tPZfX',
    billingCycle: 'month',
    price: 10,
    currency: 'USD',
    currencySymbol: '$',
  },
  plan_SdHW7OJTywPHpw: {
    name: 'Starter_Quarter',
    label: 'Starter',
    key: plansKeys.starter,
    id: 'plan_SdHW7OJTywPHpw',
    billingCycle: 'quarter',
    price: 18,
    currency: 'USD',
    currencySymbol: '$',
  },
  plan_SdHWwRa5PdZ7tw: {
    name: 'Grow_Quarter',
    label: 'Grow',
    key: plansKeys.grow,
    id: 'plan_SdHWwRa5PdZ7tw',
    billingCycle: 'quarter',
    price: 27,
    currency: 'USD',
    currencySymbol: '$',
  },
  plan_SdHXyJZxjOFBXB: {
    name: 'Starter_Year',
    label: 'Starter',
    key: plansKeys.starter,
    id: 'plan_SdHXyJZxjOFBXB',
    billingCycle: 'year',
    price: 60,
    currency: 'USD',
    currencySymbol: '$',
  },
  plan_SdHYd5RBP4vS21: {
    name: 'Grow_Year',
    label: 'Grow',
    key: plansKeys.grow,
    id: 'plan_SdHYd5RBP4vS21',
    billingCycle: 'year',
    price: 96,
    currency: 'USD',
    currencySymbol: '$',
  },

  // sandbox / local & staging
  plan_SbHlusD7D4wiwP: {
    name: 'Starter_Month',
    label: 'Starter',
    key: plansKeys.starter,
    id: 'plan_SbHlusD7D4wiwP',
    billingCycle: 'month',
    price: 7,
    currency: 'USD',
    currencySymbol: '$',
  },
  plan_SbHoogWSxvPoXV: {
    name: 'Grow_Month',
    label: 'Grow',
    key: plansKeys.grow,
    id: 'plan_SbHoogWSxvPoXV',
    billingCycle: 'month',
    price: 10,
    currency: 'USD',
    currencySymbol: '$',
  },
  plan_SbHmW5DAAY88sC: {
    name: 'Starter_Quarter',
    label: 'Starter',
    key: plansKeys.starter,
    id: 'plan_SbHmW5DAAY88sC',
    billingCycle: 'quarter',
    price: 18,
    currency: 'USD',
    currencySymbol: '$',
  },
  plan_SbHpFNugWa6PuP: {
    name: 'Grow_Quarter',
    label: 'Grow',
    key: plansKeys.grow,
    id: 'plan_SbHpFNugWa6PuP',
    billingCycle: 'quarter',
    price: 27,
    currency: 'USD',
    currencySymbol: '$',
  },
  plan_SbHnqfZMaiNdKt: {
    name: 'Starter_Year',
    label: 'Starter',
    key: plansKeys.starter,
    id: 'plan_SbHnqfZMaiNdKt',
    billingCycle: 'year',
    price: 60,
    currency: 'USD',
    currencySymbol: '$',
  },
  plan_SbHptdYX1Op9iN: {
    name: 'Grow_Year',
    label: 'Grow',
    key: plansKeys.grow,
    id: 'plan_SbHptdYX1Op9iN',
    billingCycle: 'year',
    price: 96,
    currency: 'USD',
    currencySymbol: '$',
  },

  // India plans (INR) - test
  plan_SeSGzwFlhc87nU: {
    name: 'Starter_Month_INR',
    label: 'Starter',
    key: plansKeys.starter,
    id: 'plan_SeSGzwFlhc87nU',
    billingCycle: 'month',
    price: 650,
    currency: 'INR',
    currencySymbol: '₹',
  },
  plan_SeWwi7Loi91ClX: {
    name: 'Grow_Month_INR',
    label: 'Grow',
    key: plansKeys.grow,
    id: 'plan_SeWwi7Loi91ClX',
    billingCycle: 'month',
    price: 930,
    currency: 'INR',
    currencySymbol: '₹',
  },
  plan_SeXk20vnrGbnTo: {
    name: 'Starter_Quarter_INR',
    label: 'Starter',
    key: plansKeys.starter,
    id: 'plan_SeXk20vnrGbnTo',
    billingCycle: 'quarter',
    price: 1650,
    currency: 'INR',
    currencySymbol: '₹',
  },
  plan_SeXkrddVcI3ZJV: {
    name: 'Grow_Quarter_INR',
    label: 'Grow',
    key: plansKeys.grow,
    id: 'plan_SeXkrddVcI3ZJV',
    billingCycle: 'quarter',
    price: 2490,
    currency: 'INR',
    currencySymbol: '₹',
  },
  plan_SeXliBDcnW5KW8: {
    name: 'Starter_Year_INR',
    label: 'Starter',
    key: plansKeys.starter,
    id: 'plan_SeXliBDcnW5KW8',
    billingCycle: 'year',
    price: 5400,
    currency: 'INR',
    currencySymbol: '₹',
  },
  plan_SeXmKzn3TXt2bi: {
    name: 'Grow_Year_INR',
    label: 'Grow',
    key: plansKeys.grow,
    id: 'plan_SeXmKzn3TXt2bi',
    billingCycle: 'year',
    price: 8760,
    currency: 'INR',
    currencySymbol: '₹',
  },

  // India plans (INR) - production
  plan_SeYMenfrC0VzBy: {
    name: 'Starter_Month_INR',
    label: 'Starter',
    key: plansKeys.starter,
    id: 'plan_SeYMenfrC0VzBy',
    billingCycle: 'month',
    price: 650,
    currency: 'INR',
    currencySymbol: '₹',
  },
  plan_SeYN5drWnJN6K3: {
    name: 'Grow_Month_INR',
    label: 'Grow',
    key: plansKeys.grow,
    id: 'plan_SeYN5drWnJN6K3',
    billingCycle: 'month',
    price: 930,
    currency: 'INR',
    currencySymbol: '₹',
  },
  plan_SeYNyMJ3XomqcF: {
    name: 'Starter_Quarter_INR',
    label: 'Starter',
    key: plansKeys.starter,
    id: 'plan_SeYNyMJ3XomqcF',
    billingCycle: 'quarter',
    price: 1650,
    currency: 'INR',
    currencySymbol: '₹',
  },
  plan_SeYOHuHkKebIUi: {
    name: 'Grow_Quarter_INR',
    label: 'Grow',
    key: plansKeys.grow,
    id: 'plan_SeYOHuHkKebIUi',
    billingCycle: 'quarter',
    price: 2490,
    currency: 'INR',
    currencySymbol: '₹',
  },
  plan_SeYOwXFDjU7d22: {
    name: 'Starter_Year_INR',
    label: 'Starter',
    key: plansKeys.starter,
    id: 'plan_SeYOwXFDjU7d22',
    billingCycle: 'year',
    price: 5400,
    currency: 'INR',
    currencySymbol: '₹',
  },
  plan_SeYPNPJkKQEmzf: {
    name: 'Grow_Year_INR',
    label: 'Grow',
    key: plansKeys.grow,
    id: 'plan_SeYPNPJkKQEmzf',
    billingCycle: 'year',
    price: 8760,
    currency: 'INR',
    currencySymbol: '₹',
  },
};
export default appConfig;
